import * as React from 'react';
import { translate } from 'components/translate-hoc';

// services
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

// components
import PageSupportBlockContainer from 'modules/page-support-block';
import ResubmitCodeButton from '../../resubmit-code-button';

// constants
import { WIDGET_NAME } from '@sitegen/common/constants';
import { ERROR_KEYS } from 'constants/app.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';
import {
    ERROR_MESSAGE_KEYS,
    trackingFlowStepInitialData,
    trackingFlowStepOnClickAnotherCodeBtnOptions
} from './redemption-error.constants';
import { REDEMPTION_STATUS } from '../redemption.constants';

// utils
import { getTrackingFlowStepDetails } from './redemption-error.utils';
import { getTrackingFlowSubType } from 'utils/analytics';

// types
import { ITranslationProps } from 'types/translation';

// styles
import './redemption-error.styles.less';

export class RedemptionError extends React.Component<IRedemptionErrorProps, {}> {
    public componentDidMount() {
        const { redemptionStatus: status, maintenanceMode, widgetName } = this.props;

        AnalyticsService.sendFlowEvent({
            ...trackingFlowStepInitialData,
            flowStepDetails: getTrackingFlowStepDetails({
                status: status || '',
                maintenanceMode
            }),
            flowSubType: getTrackingFlowSubType(widgetName),
            category: CATEGORY.DISPLAY
        });
    }

    public renderResubmitButton = (redemptionStatus: string | null) => {
        return [
            REDEMPTION_STATUS.CODE_ALREADY_REDEEMED,
            REDEMPTION_STATUS.USER_ALREADY_REDEEMED,
            REDEMPTION_STATUS.INVALID_CODE
        ].includes(redemptionStatus as REDEMPTION_STATUS)
            ? <div className="sitegen-error-page__resubmit">
                <ResubmitCodeButton additionalAnalyticsInfo={{
                    ...trackingFlowStepOnClickAnotherCodeBtnOptions,
                    flowSubType: getTrackingFlowSubType(this.props.widgetName),
                    category: CATEGORY.ACTION,
                }}/>
            </div>
            : null;
    };

    public render(): JSX.Element {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            redemptionStatus,
            maintenanceMode
        } = this.props;

        const errorMessageTitle = translateKey(ERROR_KEYS.WIDGET_ERROR_TITLE);
        const errorMessageKey = maintenanceMode
            ? ERROR_MESSAGE_KEYS.MAINTENANCE_ERROR
            : redemptionStatus
                ? ERROR_MESSAGE_KEYS[redemptionStatus]
                : ERROR_MESSAGE_KEYS.GENERIC_ERROR;
        const errorMessageContent = translateKey(errorMessageKey);
        const flowStepDetails = getTrackingFlowStepDetails({ status: redemptionStatus || '', maintenanceMode });

        return (
            <div className="sitegen-error-page__container">
                <div className="sitegen-error-page__title">{errorMessageTitle}</div>
                <div className="sitegen-error-page__content">
                    {errorMessageContent}
                    {this.renderResubmitButton(redemptionStatus)}
                </div>

                <PageSupportBlockContainer flowStepDetails={flowStepDetails}/>
            </div>
        );
    }
}

export interface IRedemptionErrorProps extends ITranslationProps {
    redemptionStatus: string | null;
    maintenanceMode: boolean;
    widgetName: WIDGET_NAME;
}

export default translate()(RedemptionError);
